__turbopack_context__.v({
  "header-title": "styles-module__tiKKlW__header-title",
  "subscribe-cta-container": "styles-module__tiKKlW__subscribe-cta-container",
  "subscription-modal-header": "styles-module__tiKKlW__subscription-modal-header",
});
